import styled from 'styled-components';

const SkeletonContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem 1rem;
  direction: ${({ $isRTL }) => ($isRTL ? 'rtl' : 'ltr')};
  text-align: center;
`;

const SkeletonTitle = styled.div`
  width: 200px;
  height: 32px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.card_light} 25%,
    ${({ theme }) => theme.card} 50%,
    ${({ theme }) => theme.card_light} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 8px;
  margin: 0 auto 1rem;
  direction: ${({ $isRTL }) => ($isRTL ? 'rtl' : 'ltr')};
  text-align: ${({ $isRTL }) => ($isRTL ? 'right' : 'left')};
`;

const SkeletonDesc = styled.div`
  width: 100%;
  max-width: 600px;
  height: 20px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.card_light} 25%,
    ${({ theme }) => theme.card} 50%,
    ${({ theme }) => theme.card_light} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 4px;
  margin: 0 auto 3rem;
  direction: ${({ $isRTL }) => ($isRTL ? 'rtl' : 'ltr')};
  text-align: ${({ $isRTL }) => ($isRTL ? 'right' : 'left')};
`;

const SkeletonCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  width: 100%;
  max-width: 650px;
  margin: 0 auto;
  direction: ${({ $isRTL }) => ($isRTL ? 'rtl' : 'ltr')};
`;

const SkeletonCard = styled.div`
  width: 100%;
  height: 140px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.card_light} 25%,
    ${({ theme }) => theme.card} 50%,
    ${({ theme }) => theme.card_light} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 10px;
  padding: 1rem;
`;

const SkeletonContent = styled.div`
  display: flex;
  gap: 0.75rem;
`;

const SkeletonImage = styled.div`
  width: 40px;
  height: 40px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.card} 25%,
    ${({ theme }) => theme.card_light} 50%,
    ${({ theme }) => theme.card} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 8px;
`;

const SkeletonTextGroup = styled.div`
  flex: 1;
`;

const SkeletonText = styled.div`
  height: 16px;
  background: linear-gradient(90deg, ${({ theme }) => theme.card_light} 25%, ${({ theme }) => theme.card} 50%, ${({ theme }) => theme.card_light} 75%);
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 4px;
  margin-bottom: 0.5rem;
  width: ${(props) => props.width || '80%'};
  margin-${({ $isRTL }) => ($isRTL ? 'right' : 'left')}: auto;
  direction: ${({ $isRTL }) => ($isRTL ? 'rtl' : 'ltr')};
  text-align: ${({ $isRTL }) => ($isRTL ? 'right' : 'left')};
`;

const EducationSkeleton = ({ $isRTL = false }) => (
  <SkeletonContainer $isRTL={$isRTL}>
    <SkeletonTitle $isRTL={$isRTL} className="skeleton-enhanced" />
    <SkeletonDesc $isRTL={$isRTL} className="skeleton-enhanced" />
    <SkeletonCardsContainer>
      {[...Array(2)].map((_, i) => (
        <SkeletonCard key={i} className="skeleton-enhanced">
          <SkeletonContent>
            <SkeletonImage className="skeleton-enhanced-dark" />
            <SkeletonTextGroup>
              <SkeletonText
                width="70%"
                $isRTL={$isRTL}
                className="skeleton-enhanced"
              />
              <SkeletonText
                width="50%"
                $isRTL={$isRTL}
                className="skeleton-enhanced"
              />
              <SkeletonText
                width="60%"
                $isRTL={$isRTL}
                className="skeleton-enhanced"
              />
              <SkeletonText
                width="40%"
                $isRTL={$isRTL}
                className="skeleton-enhanced"
              />
            </SkeletonTextGroup>
          </SkeletonContent>
        </SkeletonCard>
      ))}
    </SkeletonCardsContainer>
  </SkeletonContainer>
);

export default EducationSkeleton;
